import { useLoginAlert } from 'context/LoginAlertProvider'
import styled, { css } from 'styled-components'
import { useGqlRelatedCompaniesQuery } from 'generated/graphql'
import { COMPANY_TYPE_LABELS } from '@app.feature/companyInfo/constants/companyType'
import CompanyInfoCardVertical from '@app.feature/companyInfo/main/mobile/components/CompanyInfoCardVertical'
import { TCompanyInfoCard } from '@app.feature/companyInfo/main/type/companyInfoCard'

const CompanyInfoRelated = ({ companyId }: { companyId: string }) => {
  const { checkLogin } = useLoginAlert()
  const { data } = useGqlRelatedCompaniesQuery({
    variables: {
      companyId,
    },
    fetchPolicy: 'cache-first',
  })

  const relatedCompanies = data?.relatedCompanies || []
  const relatedCompaniesData: TCompanyInfoCard[] = relatedCompanies.map(
    (company) => ({
      companyId: company.id,
      companyInformationId: company.companyInformation?.id || '',
      companyName: company.name,
      companyLogo: company.companyInformation?.thumbnailImage?.url || '',
      isHiring: company.companyInformation?.isRecruiting || false,
      isLiked: company.companyInformation?.viewerInterestedIn || false,
      companyType:
        COMPANY_TYPE_LABELS[company.companyInformation?.companyType || ''] ||
        '',
      industryType:
        company.companyInformation?.companyIndustry?.secondary || '',
      likesCount: company.interestCount,
      viewsCount: company.viewCount,
    }),
  )

  return (
    <StyledWrapper>
      <header>
        <h2>이 기업 조회자가 많이 본 기업</h2>
      </header>
      <ul className="related-list">
        {relatedCompaniesData.map((item) => (
          <li key={item.companyInformationId}>
            <CompanyInfoCardVertical
              data={item}
              checkLogin={checkLogin}
              relatedCompanyId={companyId}
            />
          </li>
        ))}
      </ul>
    </StyledWrapper>
  )
}

export default CompanyInfoRelated

const StyledWrapper = styled.section`
  ${({ theme }) => css`
    width: 100%;
    margin-top: 10px;
    background-color: ${theme.background.bg_8};
    padding: 20px !important;

    > header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 16px;

      > h2 {
        font-size: 18px;
        font-weight: bold;
        line-height: 1.6;
        margin: 0;
      }
    }
    .related-list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 40px 10px;
      > li {
        min-width: 0px;
      }
    }
  `}
`
